const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.borderRadius = "3px";
    tooltipElement.style.color = "black";
    tooltipElement.style.maxWidth = "max-content";
    tooltipElement.style.width = "100%";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(-80%, 0)";
    tooltipElement.style.transition = "all .1s ease";
    tooltipElement.style.zIndex = 1;

    const table = document.createElement("table");
    table.style.margin = "0px";
    table.style.width = "100%"; // Set the table to 100% width

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const accountAnalyticTooltipHandler = (context) => {
  // Tooltip Element
  const { chart, tooltip } = context;
  const dataPoint = tooltip.dataPoints?.[0];
  const dataPoints = context.tooltip.dataPoints;

  const {
    label,
    dataIndex,
    dataset: { data },
  } = dataPoint;

  const tooltipElement = getOrCreateTooltip(chart);

  // Hide if no tooltip or no data for the given dataIndex
  if (!data?.[dataIndex] || tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip?.body && tooltip?.body?.length > 0) {
    const table = tooltipElement.querySelector("table");
    table.style.width = "100%";

    const tableHead = document.createElement("thead");
    const firstRow = document.createElement("tr");

    const titleElement = document.createElement("span");
    titleElement.textContent = `${label} - Amount (Transmission)`;
    titleElement.style.fontSize = "14px";
    titleElement.style.fontWeight = 600;

    firstRow.appendChild(titleElement);
    tableHead.appendChild(firstRow);

    const tableBody = document.createElement("tbody");

    if (dataPoints?.length > 0) {
      dataPoints?.forEach(
        ({
          dataIndex,
          dataset: { backgroundColor, expected, actual } = {},
        }) => {
          const expectedLabels = expected?.[dataIndex];
          const actualLabels = actual?.[dataIndex];

          const rowElement = document.createElement("span");
          const leftColumnElement = document.createElement("td");
          const rightColumnElement = document.createElement("td");

          expectedLabels?.forEach((pointLabel) => {
            const title = pointLabel?.title;
            const count = pointLabel?.count;
            const amount = pointLabel?.amount;

            const blockElement = document.createElement("tr");
            const contentElement = document.createElement("td");
            const valueElement = document.createElement("td");
            valueElement.setAttribute("align", "right");

            contentElement.textContent = title;

            contentElement.style.paddingLeft =
              title === "Expected" || title === "Actual" ? "0px" : "15px";

            valueElement.style.textAlign = "right";
            valueElement.textContent = `${amount} (${count})`;
            valueElement.style.fontWeight = 400;

            if (title === "Expected" || title === "Actual") {
              const span = document.createElement("span");

              span.style.background = backgroundColor;
              span.style.borderWidth = "2px";
              span.style.borderRadius = "50%";
              span.style.marginRight = "5px";
              span.style.width = "10px";
              span.style.height = "10px";
              span.style.display = "inline-block";

              contentElement.prepend(span);
              contentElement.style.fontWeight = 500;

              valueElement.style.fontWeight = 500;
            }

            blockElement.appendChild(contentElement);
            blockElement.appendChild(valueElement);

            leftColumnElement.appendChild(blockElement);
          });

          actualLabels?.forEach((pointLabel) => {
            const title = pointLabel?.title;
            const count = pointLabel?.count;
            const amount = pointLabel?.amount;

            const blockElement = document.createElement("tr");
            const contentElement = document.createElement("td");
            const valueElement = document.createElement("td");
            valueElement.setAttribute("align", "right");

            contentElement.textContent = title;

            contentElement.style.paddingLeft =
              title === "Expected" || title === "Actual" ? "0px" : "15px";

            valueElement.style.textAlign = "right";
            valueElement.textContent = `${amount} (${count})`;
            valueElement.style.fontWeight = 400;

            if (title === "Expected" || title === "Actual") {
              const span = document.createElement("span");

              span.style.background = backgroundColor;
              span.style.borderWidth = "2px";
              span.style.borderRadius = "50%";
              span.style.marginRight = "5px";
              span.style.width = "10px";
              span.style.height = "10px";
              span.style.display = "inline-block";

              contentElement.prepend(span);
              contentElement.style.fontWeight = 500;

              valueElement.style.fontWeight = 500;
            }

            blockElement.appendChild(contentElement);
            blockElement.appendChild(valueElement);

            rightColumnElement.appendChild(blockElement);
          });

          rowElement.appendChild(rightColumnElement);
          rowElement.firstChild.appendChild(leftColumnElement);
          rowElement.style.marginRight = "10px";

          tableBody.append(rowElement);
        }
      );
    }

    // Remove old children
    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(tableHead);
    table.appendChild(tableBody);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Adjust tooltip position to be slightly left of the bar chart
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX - 91 + "px"; // Adjust -20 for slight left position
  tooltipElement.style.top = positionY + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
